import React, { Component } from 'react';
import MicTest from "../../webrtc-validator/mictest";
import TestCase from "./test_case";

export default class AudioTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioInputs: [],
      audioSelected: "",
      goNextState: false,
    };
    //this.testCase = new TestCase({ name: "Audio Test" });
    this.micTest = new MicTest();
    this.onDeviceSelectorChange = this.onDeviceSelectorChange.bind(this);
    this.onTestFinished = this.onTestFinished.bind(this);
  }

  componentDidMount() {
    // we get the media devices available
    let self = this;
    navigator.mediaDevices.enumerateDevices()
        .then(function(sourceInfos) {
          sourceInfos
              .filter(source => source.kind === "audioinput")
              .map(source => self.setState({ audioInputs: [...self.state.audioInputs, source] }));
        })
        .catch(function(err) {
          console.log('JS Device selection not supported', err);
        });
  }

  onDeviceSelectorChange(event) {
    this.setState({ audioSelected: event.target.value });
  }

  onTestFinished(testState) {
    this.setState({ goNextState: testState });
  }

  render() {
    return (
        <div>
          <h3 className={"text-center"}>Prueba de Audio</h3>
          <h4 className='text-center'>Paso {this.props.currentStep} de {this.props.totalSteps}</h4>
          <p>
            Esta prueba, permitirá evaluar si el dispositivo de audio de su computador permitirá establecer una conversación
            adecuada durante la video-conferencia. Para comenzar, Ud. deberá seleccionar un dispositivo de audio de su
            computador. Normalmente el dispositivo se debería llamar <strong>"Micrófono interno"</strong> o <strong>"default".</strong>
          </p>
          <p>
            Una vez seleccionado el dispositivo, presione en el botón <strong>"Ejecutar Test"</strong>.
          </p>
          <div className={"form-group"}>
            <select value={this.state.audioSelected} onChange={this.onDeviceSelectorChange} className={"form-control"}>
              <option value="">Seleccionar dispositivo...</option>
              { this.state.audioInputs.map((device, idx) => <option key={idx} value={device.deviceId}>{device.label}</option>) }
            </select>
          </div>

          <TestCase device={this.state.audioSelected} runnable={this.micTest} onFinish={this.onTestFinished} />
          <button className='btn btn-primary btn-block' disabled={!this.state.goNextState} onClick={this.props.nextStep}>
            Siguiente
          </button>
        </div>
    );
  }
}
